module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/15-23e470425d36f9e40f0a6b0e6578e49b.jpg";